import { normalizeSmartSearchText } from '../search/smartSearch';

/**
 * Un tag mnemonico e' un'etichetta leggibile: gli incolla da tastiera touch,
 * CSV e testo libero possono contenere piu' valori separati da virgola,
 * punto e virgola o nuova riga. La dedup della singola operazione segue la
 * stessa normalizzazione della ricerca (spazi, maiuscole e accenti).
 */
export function parseMnemonicTagNames(
  values: string | readonly string[],
  uppercase = true,
): string[] {
  const sources = Array.isArray(values) ? values : [values];
  const seen = new Set<string>();
  const parsed: string[] = [];

  for (const source of sources) {
    for (const part of source.split(/[,;\n]/)) {
      const displayName = part.normalize('NFC').trim().replace(/\s+/g, ' ');
      const normalizedDisplayName = uppercase ? displayName.toLocaleUpperCase('it-IT') : displayName;
      const key = normalizeSmartSearchText(normalizedDisplayName);
      if (!key || seen.has(key)) continue;
      seen.add(key);
      parsed.push(normalizedDisplayName);
    }
  }

  return parsed;
}
